import { Box } from "@mui/material";
import styled from "styled-components";

export const ContainerStyled = styled(Box)`
  padding: 56px;
  height: 100%;

  @media (max-width: 768px) {
    padding: 56px 24px !important;
  }
`;
